module.exports = __webpack_public_path__ + "img/zn.497066d0.png";